import { useEffect } from "react";

interface PageMetadata {
  title: string;
  description: string;
}

export function usePageMetadata({ title, description }: PageMetadata) {
  useEffect(() => {
    document.title = title;

    const descriptionMeta = document.querySelector(
      'meta[name="description"]',
    );

    if (descriptionMeta instanceof HTMLMetaElement) {
      descriptionMeta.setAttribute("content", description);
    }
  }, [description, title]);
}
